<template>
  <NotMobile__WP_Alert />
  <router-view v-if="allow"/>
  <Loader v-else />
</template>

<script>
  import route_check from "@/libs/route_check";
  import Loader from "@/components/Different/Loader.vue";
  import NotMobile__WP_Alert from "@/components/wp_planner/alerts/not_mobile.alert.vue";

  export default {
    name: "WP_Handler",
    components: {NotMobile__WP_Alert, Loader },
    data() {
      return {
        allow: false
      }
    },
    async beforeMount() {
      route_check('/operate').then(async res => {
        if (res) {
          this.allow = true
        }
      })
    }
  }
</script>
